import { Router,ActivatedRoute,NavigationExtras } from '@angular/router';
import { Storage } from '@ionic/storage';
import { LoaderService } from './../loder_service/loader.service';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit {
  deliaddress:FormGroup
  public deliname	:any;
  public deliemail:any;
  public delimob:any;
  public delipin:any;
  public delicity	:any;
  public delistate:any;
  public deliadd:any;
  public serverData:any;
  public delicountry:any;
  public deliland:any;
  public total_price:any;
  public cart_count:any;
  public shipping_charge:any;
  public total_order_amount:any;
  constructor(public route:ActivatedRoute, public router:Router, public fb:FormBuilder,public storage:Storage, public restApi:DataService, public toastService:LoaderService) { 

    this.deliaddress = fb.group({
      "deliname"      :  ["", Validators.required],
      "deliemail"      :  ["", Validators.required],
      "delimob"      :  ["", Validators.required],
      "delipin"      :  ["", Validators.required],
      "delicity"      :  ["", Validators.required],
      "delistate"      :  ["", Validators.required],
      "deliadd"      :  ["", Validators.required],
      "delicountry"      :  ["", Validators.required],
      "deliland"      :  ["", Validators.required],  
   });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.total_price))
      this.total_price=JSON.parse(params.total_price);
      this.shipping_charge=JSON.parse(params.shipping_charge);
      this.total_order_amount=JSON.parse(params.total_order_amount);
    });
  }
ionViewWillEnter(){
  
    if(localStorage.getItem('cart_count')){
      this.cart_count= localStorage.getItem('cart_count');
     
    }else{
      this.cart_count='';
    }



  this.toastService.showLoader('')

   let postpramrs={
    usersessionid: localStorage.getItem('user_id')
   }
   this.restApi.get_deli_addres(postpramrs).subscribe((data:any)=>{
      this.serverData=data
     
      this.deliname	=this.serverData.deliname	;
      this.deliemail=this.serverData.deliemail;
      this.delimob=this.serverData.delimob;
      this.delipin=this.serverData.delipin;
      this.delicity	=this.serverData.delicity	;
      this.delistate=this.serverData.delistate;
      this.deliadd=this.serverData.deliadd;
      this.delistate=this.serverData.delistate;
      this.delicountry=this.serverData.delicountry;
      this.deliland=this.serverData.deliland;
      this.toastService.hideLoader()
    
   },(error:any)=>{
    this.toastService.hideLoader()
   })
 
}
pay(){
  if(this.deliaddress.valid){
    
      let postprams={
        "usersessionid" : localStorage.getItem('user_id'),
        "deliname" : this.deliname,
        "deliemail" : this.deliemail,
        "delimob" : this.delimob,
        "delipin" : this.delipin,
      
        "delicity" : this.delicity,
        "delistate" : this.delistate,
        "delicountry" :this.delicountry,
        "deliadd" : this.deliadd,
        "deliland" : this.deliland
  
      }
      console.log(postprams)
      this.restApi.aa_deli_addres(postprams).subscribe((data:any)=>{
        if(data.result==1){
          //this.router.navigate(['/paymentmethod'])
          let navigationExtras: NavigationExtras = {
            queryParams: {
              total_price: JSON.stringify(this.total_price),
              shipping_charge: JSON.stringify(this.shipping_charge),
              total_order_amount: JSON.stringify(this.total_order_amount)
            }
          };
          this.router.navigate(['/paymentmethod'], navigationExtras); 
        }else{

        }
      },(error:any)=>{})
   
  }else{
    this.toastService.create('Please fill all required field')
  }

  
}
}
